"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPAQUE = exports.SEMANTIC_COLOR_NAME = void 0;
var SEMANTIC_COLOR_NAME = {
  // SEMANTIC COLOR NAMES
  // these are pretty much all text and function related
  // and should be mapped as closely to the design system
  // colors as possible.
  CTA_PRIMARY: 'ctaPrimary',
  CTA_SECONDARY: 'ctaSecondary',
  FOCUS_PRIMARY: 'focusPrimary',
  TEXT_PRIMARY: 'textPrimary',
  TEXT_SECONDARY: 'textSecondary',
  TEXT_TERTIARY: 'textTertiary',
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
  LINK: 'link',
  DISABLED: 'disabled',
  STROKE: 'stroke',
  DARK: 'dark',
  DARK_SUBCOPY: 'darkSubcopy',
  DARK_TERTIARY: 'darkTertiary',
  DARK_GHOST: 'darkGhost',
  LIGHT: 'light',
  LIGHT_SUBCOPY: 'lightSubcopy',
  LIGHT_TERTIARY: 'lightTertiary',
  LIGHT_GHOST: 'lightGhost',
  // DESIGN SYSTEM COLORS
  CORE1_100: 'core1_100',
  CORE1_75: 'core1_75',
  CORE1_50: 'core1_50',
  CORE1_25: 'core1_25',
  CORE1_10: 'core1_10',
  CORE1_75_OPAQUE: 'core1_75_opaque',
  CORE1_50_OPAQUE: 'core1_50_opaque',
  CORE1_25_OPAQUE: 'core1_25_opaque',
  CORE1_10_OPAQUE: 'core1_10_opaque',
  CORE2_100: 'core2_100',
  CORE2_75: 'core2_75',
  CORE2_50: 'core2_50',
  CORE2_25: 'core2_25',
  CORE2_10: 'core2_10',
  CORE2_75_OPAQUE: 'core2_75_opaque',
  CORE2_50_OPAQUE: 'core2_50_opaque',
  CORE2_25_OPAQUE: 'core2_25_opaque',
  CORE2_10_OPAQUE: 'core2_10_opaque',
  CORE3_100: 'core3_100',
  CORE3_75: 'core3_75',
  CORE3_50: 'core3_50',
  CORE3_25: 'core3_25',
  CORE3_10: 'core3_10',
  CORE3_75_OPAQUE: 'core3_75_opaque',
  CORE3_50_OPAQUE: 'core3_50_opaque',
  CORE3_25_OPAQUE: 'core3_25_opaque',
  CORE3_10_OPAQUE: 'core3_10_opaque',
  CORE4_100: 'core4_100',
  CORE4_75: 'core4_75',
  CORE4_50: 'core4_50',
  CORE4_25: 'core4_25',
  CORE4_10: 'core4_10',
  CORE4_75_OPAQUE: 'core4_75_opaque',
  CORE4_50_OPAQUE: 'core4_50_opaque',
  CORE4_25_OPAQUE: 'core4_25_opaque',
  CORE4_10_OPAQUE: 'core4_10_opaque',
  CORE5_100: 'core5_100',
  CORE5_75: 'core5_75',
  CORE5_50: 'core5_50',
  CORE5_25: 'core5_25',
  CORE5_10: 'core5_10',
  CORE5_75_OPAQUE: 'core5_75_opaque',
  CORE5_50_OPAQUE: 'core5_50_opaque',
  CORE5_25_OPAQUE: 'core5_25_opaque',
  CORE5_10_OPAQUE: 'core5_10_opaque',
  FEATURE1_100: 'feature1_100',
  FEATURE1_75: 'feature1_75',
  FEATURE1_50: 'feature1_50',
  FEATURE1_25: 'feature1_25',
  FEATURE1_10: 'feature1_10',
  FEATURE1_75_OPAQUE: 'feature1_75_opaque',
  FEATURE1_50_OPAQUE: 'feature1_50_opaque',
  FEATURE1_25_OPAQUE: 'feature1_25_opaque',
  FEATURE1_10_OPAQUE: 'feature1_10_opaque',
  FUNCTIONAL1_100: 'functional1_100',
  FUNCTIONAL1_75: 'functional1_75',
  FUNCTIONAL1_50: 'functional1_50',
  FUNCTIONAL1_25: 'functional1_25',
  FUNCTIONAL1_10: 'functional1_10',
  FUNCTIONAL1_75_OPAQUE: 'functional1_75_opaque',
  FUNCTIONAL1_50_OPAQUE: 'functional1_50_opaque',
  FUNCTIONAL1_25_OPAQUE: 'functional1_25_opaque',
  FUNCTIONAL1_10_OPAQUE: 'functional1_10_opaque',
  FUNCTIONAL2_100: 'functional2_100',
  FUNCTIONAL2_75: 'functional2_75',
  FUNCTIONAL2_50: 'functional2_50',
  FUNCTIONAL2_25: 'functional2_25',
  FUNCTIONAL2_10: 'functional2_10',
  FUNCTIONAL2_75_OPAQUE: 'functional2_75_opaque',
  FUNCTIONAL2_50_OPAQUE: 'functional2_50_opaque',
  FUNCTIONAL2_25_OPAQUE: 'functional2_25_opaque',
  FUNCTIONAL2_10_OPAQUE: 'functional2_10_opaque',
  FUNCTIONAL3_100: 'functional3_100',
  FUNCTIONAL3_75: 'functional3_75',
  FUNCTIONAL3_50: 'functional3_50',
  FUNCTIONAL3_25: 'functional3_25',
  FUNCTIONAL3_10: 'functional3_10',
  FUNCTIONAL3_75_OPAQUE: 'functional3_75_opaque',
  FUNCTIONAL3_50_OPAQUE: 'functional3_50_opaque',
  FUNCTIONAL3_25_OPAQUE: 'functional3_25_opaque',
  FUNCTIONAL3_10_OPAQUE: 'functional3_10_opaque',
  GRAY_100: 'gray_100',
  GRAY_75: 'gray_75',
  GRAY_50: 'gray_50',
  GRAY_25: 'gray_25',
  GRAY_10: 'gray_10',
  GRAY_5: 'gray_5',
  GRAY_0: 'gray_0',
  GRAY_75_OPAQUE: 'gray_75_opaque',
  GRAY_50_OPAQUE: 'gray_50_opaque',
  GRAY_25_OPAQUE: 'gray_25_opaque',
  GRAY_10_OPAQUE: 'gray_10_opaque',
  GRAY_5_OPAQUE: 'gray_5_opaque',
  GRAY_0_OPAQUE: 'gray_0_opaque',
  BLACK: 'dark',
  WHITE: 'gray_0',
  TRANSPARENT: 'transparent',
  // DEPRECATED HOLD OVERS TO MAKE FANTASTIC LLAMA WORK
  CORE1_150: 'core1_150',
  CORE1_125: 'core1_125',
  CORE2_150: 'core2_150',
  CORE2_125: 'core2_125',
  FUNCTIONAL1_150: 'functional1_150',
  FUNCTIONAL1_125: 'functional1_125',
  FUNCTIONAL2_150: 'functional2_150',
  FUNCTIONAL2_125: 'functional2_125',
  FUNCTIONAL3_150: 'functional3_150',
  FUNCTIONAL3_125: 'functional3_125'
};
exports.SEMANTIC_COLOR_NAME = SEMANTIC_COLOR_NAME;
var OPAQUE = {
  100: 100,
  75: 75,
  50: 50,
  25: 25,
  10: 10,
  5: 5,
  0: 0
};
exports.OPAQUE = OPAQUE;